import { axios } from '@/services/axios';

const getAllCustomSIPHeaders = async (currentScope) => {
    const res = await axios.get('/TRECustomHeaders', {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default getAllCustomSIPHeaders;
